module.exports = __webpack_public_path__ + "img/msg_error.0e0a3f20.png";